// NJIT's undergraduate majors (#2652). Read on 2026-10-01 from the official
// University Catalog 2026-2027's Degree Programs table (catalog.njit.edu/
// programs), which lists each program with its college code, degree level
// and degree: every bachelor's row kept, grouped by college (SL, EN, AD, CC
// and SM are the catalog's codes for the five colleges named here, matched
// through each program's catalog path). Left out: double majors, accelerated
// and combined bachelor's/graduate programs, the Patent Law concentration of
// Law, Technology and Culture, concentrations and options, minors,
// certificates and graduate programs. Biomedical Engineering - B.S. is
// listed twice in the table (two departments) and appears once here. Names
// and degree abbreviations are the catalog's, spelling included
// ("BioChemistry", "Materials Engineering Program"); "Business with AI" and
// "Environmental Engineering" carry no degree in the table, so degree is
// null. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "new-jersey-institute-of-technology",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in NJIT's official 2026-2027 University Catalog, grouped by the college that offers it, with the degree it leads to. Double majors, accelerated programs, concentrations, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Hillier College of Architecture and Design",
            "source": {
                "label": "NJIT University Catalog 2026-2027, Hillier College of Architecture and Design",
                "url": "https://catalog.njit.edu/undergraduate/architecture-design/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch."
                },
                {
                    "name": "Architecture",
                    "degree": "B.S."
                },
                {
                    "name": "Digital Design",
                    "degree": "B.A."
                },
                {
                    "name": "Industrial Design",
                    "degree": "B.S."
                },
                {
                    "name": "Interior Design",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Ying Wu College of Computing",
            "source": {
                "label": "NJIT University Catalog 2026-2027, Ying Wu College of Computing",
                "url": "https://catalog.njit.edu/undergraduate/computing-sciences/"
            },
            "majors": [
                {
                    "name": "Business & Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Computing and Business",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Enterprise AI",
                    "degree": "B.S."
                },
                {
                    "name": "Human-Computer Interaction",
                    "degree": "B.S."
                },
                {
                    "name": "Information Systems",
                    "degree": "B.A."
                },
                {
                    "name": "Information Technology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Jordan Hu College of Science and Liberal Arts",
            "source": {
                "label": "NJIT University Catalog 2026-2027, Jordan Hu College of Science and Liberal Arts",
                "url": "https://catalog.njit.edu/undergraduate/science-liberal-arts/"
            },
            "majors": [
                {
                    "name": "Applied Physics",
                    "degree": "B.S."
                },
                {
                    "name": "BioChemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Communication and Media",
                    "degree": "B.A."
                },
                {
                    "name": "Communication and Media",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Forensic Science",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Law, Technology and Culture",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Theatre Arts and Technology",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Martin Tuchman School of Management",
            "source": {
                "label": "NJIT University Catalog 2026-2027, Martin Tuchman School of Management",
                "url": "https://catalog.njit.edu/undergraduate/management/"
            },
            "majors": [
                {
                    "name": "Business",
                    "degree": "B.S."
                },
                {
                    "name": "Business with AI",
                    "degree": null
                },
                {
                    "name": "Financial Technology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Newark College of Engineering",
            "source": {
                "label": "NJIT University Catalog 2026-2027, Newark College of Engineering",
                "url": "https://catalog.njit.edu/undergraduate/newark-college-engineering/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Concrete Industry Management",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Management Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical and Computer Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "General Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Materials Engineering Program",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Software and Data Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Surveying Engineering Technology",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
